export function formatFormat(format: string): string {
  return format.toUpperCase().replace("_", "/");
}
